import messages from './messages';

function randomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

/**
 * Generates social proof messages at random intervals.
 *
 * @param options - Configuration options for the generator.
 * @param minTimeout- Minimum timeout in milliseconds between messages.
 * @param maxTimeout- Maximum timeout in milliseconds between messages.
 * @returns An AsyncGenerator that yields social proof messages.
 */
export default async function* socialProofGenerator({
  minTimeout = 5000,
  maxTimeout = 15000,
}: {
  maxTimeout?: number;
  minTimeout?: number;
} = {}) {
  while (true) {
    await new Promise((resolve) =>
      setTimeout(
        resolve,
        Math.random() * (maxTimeout - minTimeout) + minTimeout
      )
    );

    yield randomItem(messages);
  }
}
